import React from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import RUTAS from '../routes'

interface GoBackProps {
    to?: string
}

export const GoBack = ({ to }: GoBackProps) => {
    const navigation = useNavigate()

    return (
        <Button
            variant='text'
            color='primary'
            size='small'
            onClick={() => navigation(to ?? `/${RUTAS.PANEL}`)}
            startIcon={<ArrowBackIcon />}
        >
            Volver
        </Button>
    )
}
